import { SDKEvent } from '@pff-consumer/schema'

export const getNextUpcomingEvent = (events: SDKEvent[]) => {
  const sortedEvents = [...events].sort((a, b) => a.startTimestamp - b.startTimestamp)
  const upcomingEvent = sortedEvents.find((event) => event.startTimestamp > Date.now())

  return upcomingEvent ? upcomingEvent.eventId : sortedEvents?.[0]?.eventId
}
